import gql from 'graphql-tag';

export const SAVE_TRACKED_PROPERTY = gql`
    mutation saveTrackedProperty($trackedProperty: TrackedPropertyInput!) {
        saveTrackedProperty(trackedProperty: $trackedProperty)
    }
`;
